var _defs, _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _path10, _g4, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 447.121,
    height: 260.202,
    viewBox: "0 0 447.121 260.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.746,
    y1: 1.313,
    x2: 0.322,
    y2: -0.097,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#f0eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.003,
    y1: 1.072,
    x2: 0.995,
    y2: -0.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#169ac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#1ec2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.579,
    y1: 0.473,
    x2: -0.269,
    y2: -0.384,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#feb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee0a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20.282,
    y1: 23.244,
    x2: -7.847,
    y2: -9.097,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#ae24b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#d643bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545",
    transform: "translate(-143 -72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2550",
    "data-name": "Group 2550",
    transform: "translate(-43.382 -3.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2545-2",
    "data-name": "Group 2545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M359.183,77.5l-172.8,100.336L459.109,335.5,633.5,233.57Z",
    fill: "#d1d3d4",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M359.276,77.755,186.9,177.845,458.956,335.122,632.921,233.444Z",
    fill: "#d0d2d3",
    opacity: 0.121,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M359.369,78.013,187.418,177.856,458.8,334.746,632.339,233.319Z",
    fill: "#cfd1d2",
    opacity: 0.143,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M359.463,78.272l-171.526,99.6L458.65,334.37,631.758,233.193Z",
    fill: "#ced0d1",
    opacity: 0.164,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M359.556,78.53l-171.1,99.349L458.5,333.993,631.176,233.067Z",
    fill: "#cdcfd0",
    opacity: 0.186,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M359.649,78.788l-170.676,99.1L458.345,333.617,630.594,232.942Z",
    fill: "#cccecf",
    opacity: 0.207,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M359.742,79.047,189.491,177.9l268.7,155.339,171.82-100.425Z",
    fill: "#cbcdce",
    opacity: 0.229,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M359.835,79.3,190.009,177.913,458.04,332.864,629.431,232.69Z",
    fill: "#cacccd",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M359.928,79.563l-169.4,98.362L457.887,332.488l170.962-99.923Z",
    fill: "#c9cbcc",
    opacity: 0.271,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M360.021,79.821,191.046,177.936,457.734,332.111l170.533-99.672Z",
    fill: "#c8cacb",
    opacity: 0.293,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M360.115,80.08,191.564,177.948,457.582,331.735l170.1-99.421Z",
    fill: "#c7c9ca",
    opacity: 0.314,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M360.208,80.338,192.082,177.959l265.347,153.4L627.1,232.188Z",
    fill: "#c6c8c9",
    opacity: 0.336,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M360.3,80.6,192.6,177.971,457.276,330.982l169.246-98.92Z",
    fill: "#c5c7c8",
    opacity: 0.357,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M360.394,80.854,193.119,177.982l264,152.623L625.94,231.936Z",
    fill: "#c4c6c7",
    opacity: 0.379,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M360.487,81.113l-166.85,96.881L456.971,330.229l168.388-98.418Z",
    fill: "#c3c5c6",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M360.58,81.371,194.155,178.005,456.818,329.853l167.959-98.168Z",
    fill: "#c2c4c5",
    opacity: 0.421,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M360.673,81.629l-166,96.387,261.992,151.46L624.2,231.559Z",
    fill: "#c1c3c4",
    opacity: 0.443,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M360.766,81.888l-165.575,96.14L456.513,329.1l167.1-97.666Z",
    fill: "#c0c2c3",
    opacity: 0.464,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M360.859,82.146,195.71,178.039,456.36,328.724l166.672-97.415Z",
    fill: "#bfc1c2",
    opacity: 0.486,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M360.953,82.4,196.228,178.051l259.979,150.3L622.45,231.182Z",
    fill: "#bec0c1",
    opacity: 0.507,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M361.046,82.662l-164.3,95.4L456.055,327.971l165.814-96.914Z",
    fill: "#bdbfc0",
    opacity: 0.529,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M361.139,82.921,197.264,178.074,455.9,327.594l165.385-96.663Z",
    fill: "#bdbfc0",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M361.232,83.179,197.783,178.085,455.749,327.218l164.956-96.413Z",
    fill: "#bcbebf",
    opacity: 0.571,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M361.325,83.437,198.3,178.1,455.6,326.842,620.123,230.68Z",
    fill: "#bbbdbe",
    opacity: 0.593,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M361.418,83.7l-162.6,94.412L455.444,326.465l164.1-95.911Z",
    fill: "#babcbd",
    opacity: 0.614,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M361.511,83.954,199.337,178.12,455.291,326.089l163.669-95.66Z",
    fill: "#b9bbbc",
    opacity: 0.636,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M361.6,84.212,199.855,178.131,455.138,325.712l163.24-95.41Z",
    fill: "#b8babb",
    opacity: 0.657,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M361.7,84.47,200.374,178.142,454.986,325.336,617.8,230.177Z",
    fill: "#b7b9ba",
    opacity: 0.679,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M361.791,84.729l-160.9,93.425L454.833,324.96l162.382-94.908Z",
    fill: "#b6b8b9",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M361.884,84.987,201.41,178.165,454.68,324.583l161.953-94.657Z",
    fill: "#b5b7b8",
    opacity: 0.721,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M361.977,85.245,201.928,178.177l252.6,146.03L616.051,229.8Z",
    fill: "#b4b6b7",
    opacity: 0.743,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M362.07,85.5,202.446,178.188,454.375,323.83,615.47,229.674Z",
    fill: "#b3b5b6",
    opacity: 0.764,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M362.163,85.762,202.965,178.2,454.222,323.454l160.666-93.905Z",
    fill: "#b2b4b5",
    opacity: 0.786,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M362.256,86.02,203.483,178.211,454.07,323.078l160.237-93.654Z",
    fill: "#b1b3b4",
    opacity: 0.807,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M362.349,86.278,204,178.223,453.917,322.7l159.808-93.4Z",
    fill: "#b0b2b3",
    opacity: 0.829,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M362.443,86.537l-157.923,91.7L453.764,322.325l159.379-93.153Z",
    fill: "#afb1b2",
    opacity: 0.85,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M362.536,86.795l-157.5,91.451,248.574,143.7,158.95-92.9Z",
    fill: "#aeb0b1",
    opacity: 0.871,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M362.629,87.053l-157.073,91.2,247.9,143.315,158.521-92.651Z",
    fill: "#adafb0",
    opacity: 0.893,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M362.722,87.312,206.074,178.268,453.306,321.2l158.092-92.4Z",
    fill: "#acaeaf",
    opacity: 0.914,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M362.815,87.57,206.592,178.28,453.153,320.819l157.663-92.15Z",
    fill: "#abadae",
    opacity: 0.936,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M362.908,87.828l-155.8,90.463L453,320.443l157.234-91.9Z",
    fill: "#aaacad",
    opacity: 0.957,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M363,88.086,207.629,178.3,452.848,320.066l156.8-91.648Z",
    fill: "#a9abac",
    opacity: 0.979,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M363.094,88.345,208.147,178.314,452.7,319.69l156.376-91.4Z",
    fill: "#a8aaab",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M459.109,333.3,633.5,231.37l-63.8-52.114-65.737-21.944-64.425-49.966L359.183,75.3l-172.8,100.336,79.031,32.05,65.431,51.125,64.446,21.785Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M397.763,276.151,333.25,254.344l-65.31-51.031-70.224-28.479L359.59,80.842l77.445,30.887,64.541,50.056,65.675,21.924,57.511,46.979L459.6,327.22Z",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M364.808,132.869l-6,3.667,7.333,8.667,10.667-5.333Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2546",
    "data-name": "Group 2546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M324.33,247.374,361.1,224.29l12.484,9.284a1.561,1.561,0,0,0,.415.216l7.716,2.612-18.825,11.005L364.4,250l21.666-12.667a1.5,1.5,0,0,0-.277-2.716l-10.608-3.589-11.359-8.448,10.785-6.771-1.6-2.541L321.816,245.41Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M243.3,160.04l-33.369,19.749,3.5,1.417,33.309-19.713-.13-.219,15.174,5.666,1.049-2.811-28.411-10.609-3.356,1.949Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M330.113,166.073a1.521,1.521,0,0,0,.612.129,1.5,1.5,0,0,0,.8-.229l12.458-7.817,4.667,1.991,26.808,24.823,2.039-2.2-6.275-5.811,32.873-20.143a1.5,1.5,0,0,0,.208-2.4l-18.333-16.166a1.528,1.528,0,0,0-.188-.14l-19.667-12.5-1.609,2.531,19.567,12.438,9.236,8.143-31.669,19.37-11.143-10.317a1.525,1.525,0,0,0-.43-.28l-42-17.916-1.178,2.759,33.734,14.391-10.015,6.284-51.851-23.123L299,127.739l-1.543-2.573L275.41,138.392l-8.446-3.766-3.2,1.858Zm65.547-15.281,5.132,4.526L368.931,174.84l-5.007-4.637Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M513.513,272.453l-2.076,2.164,14.447,13.861,2.692-1.573Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M402.3,265.458l-1.641-2.512-14.3,9.347,3.614,1.222Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M532.663,216.454a1.5,1.5,0,0,0,1.067,1.191l23.333,6.667.824-2.885-22.425-6.407-1.284-7.542,36.52-20.954-2.486-2.031-34.57,19.835-.689-4.045a1.5,1.5,0,0,0-.8-1.084l-7.088-3.617,28.544-16.427-3.8-1.27-27.926,16.07-21.725-11.088-1.363,2.671,31.329,15.992Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M452.448,123.682l-11.388,6.553,1.5,2.6,12.454-7.166Z",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M403.141,178.2l40.667-1.667,37-7.667,18,9.333-31.333,19.333-11.333-3-51.333,18.333-15.667-29Z",
    fill: "#cfe4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M358.475,79.2l-64.5,38.5,24,12,27-11,19,1.5,32-17.5-3-9.5Z",
    fill: "#cfe4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M418.975,221.7l-31.5,11,.5,6.5,4.5,12.5,25,11,4.5,3,2.5,2,46,10,11,7.5,23-14-11-18.5,11-21.5-10.5-8.5-36.5-16.5Z",
    fill: "#cfe4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M426.837,300.162l27.126,22.4c2.717-14.248,7.569-43.771,9.179-64.7,1.509-19.624-15.2-29.233-24-38.667-5.409-5.8-7.449-11.309-9.658-18.1-2.831-8.693-1.184-16.673.723-25.913,1.958-9.495,6.871-21.437,3.6-33.325-3.665-13.329-22.168-20.134-40.476-29.382a96.347,96.347,0,0,1-35.087-30.864l-24.7,14.339c12.532,15.085,35.584,22.144,53.592,31.24,11.058,5.586,23.377,16.372,24.691,21.152,1.994,7.252.508,14.456-1.214,22.8-2.168,10.506-7.732,23.138-3.261,36.871,3.58,11,10.772,18.709,17.117,25.513,8.786,9.422,16.827,14.533,16.029,24.9C439.415,272.585,432.292,289.225,426.837,300.162Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M486.711,293.729l74.342-45.975a3,3,0,0,0,1.421-2.632l-.956-35.858,20.226-13.717-4.849-3.961-20.1,13.634a3,3,0,0,0-1.315,2.562l.954,35.776L481.9,289.651l.058.093L471.4,280.9a3,3,0,0,0-1.356-.646l-48.1-9.325-4.851-4.851a3,3,0,0,0-1.078-.691L354.53,242.579l-49.968-43.43,58.957-35.374a3,3,0,0,0,1.26-3.637l-9.751-25.708L397.7,110.517l22.266,8.813,63.156,49.73a3.108,3.108,0,0,0,.461.3l17.2,9.03-35.4,22.274,3.195,5.079,57.089-35.917-7.361-2.458-12.187,7.668.256-.489-19.756-10.372L423.33,114.345a2.969,2.969,0,0,0-.751-.432l-24-9.5a3,3,0,0,0-2.571.172l-44.914,25.172L317.1,132.151l-24.339-12.5-6.163,3.578,23.742,12.2-83.928,51.048,6.927,2.81,84.073-51.137,31.76-2.237,9.108,24.014L297.931,196.13a3,3,0,0,0-.424,4.837l53.5,46.5a3,3,0,0,0,.925.548l18.373,6.816-12.08,7.955,7.211,2.437,11.849-7.8,36.032,13.367,5.037,5.037a3.017,3.017,0,0,0,1.549.824L468.143,286l25.47,21.34,5.5-3.217Z",
    fill: "#fee2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M502.148,215.227a3.977,3.977,0,0,0-1.061-.685l-42-18.5a3.985,3.985,0,0,0-2.94-.112L387.26,220.186l-21.783-17.709a8.77,8.77,0,0,0,2.246-5.748,8.228,8.228,0,0,0-.529-2.839l29.453-16.265,45.131-3.434a4.009,4.009,0,0,0,1.739-.549l41.543-24.667-6.794-5.269-38.029,22.579-45.066,3.429a3.994,3.994,0,0,0-1.63.486l-32.049,17.7a22.166,22.166,0,0,0-10.141-2.314,24.172,24.172,0,0,0-5.8.693L327.5,171.6a4.014,4.014,0,0,0-.976-.585l-70.961-29.767-8.673,5.036,76.01,31.885,15,12.193a8.948,8.948,0,0,0-2.759,6.279,8.429,8.429,0,0,0,1.207,4.267l-40.216,24.429,6.741,5.267L343,206.225a23.147,23.147,0,0,0,8.508,1.556,23.8,23.8,0,0,0,6.665-.934l25.78,20.959a3.988,3.988,0,0,0,3.852.669L457.311,204l39.967,17.6,56.37,50.646,7.252-4.239Zm-144-16.973a13.759,13.759,0,0,1-6.644,1.528,13.962,13.962,0,0,1-6.743-1.559c-1.219-.7-1.628-1.382-1.628-1.584s.395-.847,1.573-1.526a13.755,13.755,0,0,1,6.643-1.528,13.963,13.963,0,0,1,6.744,1.559c1.219.7,1.628,1.383,1.628,1.585S359.327,197.574,358.15,198.254Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M561.975,266.7l-10.5-10.5,14-9,16.5-43,6-2.5,35.5,29Z",
    fill: "#cfe4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M295.475,222.7l-25.5-19-2.5-19-11-7,24-15,37,14.5-2.5,7-19.5,11.5-8.5,5.5,13,3.5,4,14.5Z",
    fill: "#cfe4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M370.115,143.01a4.854,4.854,0,0,1-4.393-.008c-1.217-.7-1.223-1.838-.014-2.536a4.854,4.854,0,0,1,4.393.008C371.318,141.176,371.324,142.312,370.115,143.01Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M514.808,266.536l18-10.667-21.667-20-6.333,4.333,12,13.333-8,5Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M470.808,317.2l18-10.667-16.5-14.5-6.333,4.333L464.808,309.2Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M497.808,191.2l-14.333,9,9.49,5.32,9.038-2.67,10.139,5.684,11-6.333Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M329.475,140.2l-4,2.667,19,8.333,4-4-3.667-7Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M343.475,227.536l14.333-9-5.667-5.667-6,3.333-5.667-5.333L329.808,217.2Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M441.475,161.2l13.667-9.333-13.667-12-4.667,4.333,7.333,5.667-6.333,5.333Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M542.475,246.869l10-6.333-.333-16-7.667-1.333-2,10.333-3.667,2.667-16.333-14.333-5.333,3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M387.475,217.2l11-5.667-12.667-25-10,5.333-.333,7.333-5.333,4Z",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M503.968,157.312l-64.425-49.966L265.412,207.683l65.431,51.125Z",
    fill: "#c8cacc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M395.289,280.593,459.109,333.3,633.5,231.37l-63.8-52.114Z",
    fill: "#acacac",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    transform: "translate(383.676 86.631)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2565",
    "data-name": "Group 2565",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2564",
    "data-name": "Group 2564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2563",
    "data-name": "Group 2563",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2555",
    "data-name": "Group 2555",
    transform: "translate(27.118 53.689)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M356.646,39.244l8.695-5.051c-2.81,1.632-6.7,1.4-11-1.076l-8.691,5.051c4.293,2.479,8.187,2.709,10.992,1.076Z",
    transform: "translate(-345.654 -33.117)",
    fill: "#a9650b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2557",
    "data-name": "Group 2557",
    transform: "translate(11.723 17.089)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556",
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M363.784,65.688l8.691-5.051c-8.521-4.922-15.43-16.857-15.4-26.652.016-4.914,1.762-8.36,4.567-9.948l-8.69,5.055c-2.81,1.584-4.551,5.03-4.567,9.944-.028,9.795,6.877,21.73,15.4,26.652Z",
    transform: "translate(-348.382 -24.037)",
    fill: "#a9650b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2559",
    "data-name": "Group 2559",
    transform: "translate(7.993)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2558",
    "data-name": "Group 2558",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M367.63,28.535l8.691-5.051c-7.574-4.325-14.37-4.712-19.284-1.854l-8.69,5.051c4.914-2.858,11.71-2.471,19.284,1.854Z",
    transform: "translate(-348.346 -19.797)",
    fill: "#a9650b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2560",
    "data-name": "Group 2560",
    transform: "translate(0 5.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M371.049,24.737c-15.226-8.7-27.318-1.459-27.266,16.047.049,29.957,24.433,69.476,27.008,73.607.113.206.2.335.226.387.621-.262,27.1-11.657,27.1-42.961C398.068,54.388,385.965,33.4,371.049,24.737Zm-.145,50c-8.522-4.922-15.424-16.857-15.4-26.652.016-4.914,1.757-8.36,4.565-9.944s6.672-1.354,10.931,1.108c8.522,4.922,15.416,16.861,15.387,26.672-.028,9.795-6.967,13.737-15.488,8.815Z",
    transform: "translate(-343.783 -21.05)",
    fill: "#f49110"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2562",
    "data-name": "Group 2562",
    transform: "translate(27.255 3.687)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2561",
    "data-name": "Group 2561",
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M344.948,114.07l8.695-5.051C360.9,104.8,377.4,92.493,377.4,67.792c-.052-17.429-12.161-38.426-27.083-47.08l-8.691,5.051c14.922,8.658,27.031,29.651,27.083,47.08,0,24.7-16.5,37-23.762,41.227Z",
    transform: "translate(-341.627 -20.712)",
    fill: "#a9650b"
  })))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M365.64,26.292c11.073,6.393,20.045,21.936,20.045,34.722,0,12.766-8.977,17.949-20.045,11.556-5.53-3.192-10.557-8.682-14.172-14.962-3.636-6.276-5.877-13.358-5.877-19.739C345.591,25.082,354.568,19.9,365.64,26.292Zm0,40.889c8.485,4.9,15.378.939,15.378-8.864s-6.893-21.738-15.378-26.636C361.4,29.234,357.554,29,354.769,30.6s-4.51,5.055-4.51,9.964C350.259,50.36,357.151,62.283,365.64,67.181Z",
    transform: "translate(-338.613 -8.413)",
    fill: "#feba11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2577",
    "data-name": "Group 2577",
    transform: "translate(-0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2576",
    "data-name": "Group 2576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2575",
    "data-name": "Group 2575",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    transform: "translate(7.331 15.369)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2567",
    "data-name": "Group 2567",
    transform: "translate(27.122 53.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2566",
    "data-name": "Group 2566",
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M356.646,39.244l8.695-5.051c-2.81,1.632-6.7,1.4-11-1.076l-8.691,5.051c4.293,2.479,8.187,2.709,10.992,1.076Z",
    transform: "translate(-345.654 -33.117)",
    fill: "#972222"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    transform: "translate(11.725 17.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2568",
    "data-name": "Group 2568",
    style: {
      isolation: "isolate"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M363.784,65.688l8.691-5.051c-8.521-4.922-15.43-16.857-15.4-26.652.016-4.914,1.762-8.36,4.567-9.948l-8.69,5.055c-2.81,1.584-4.551,5.03-4.567,9.944-.028,9.795,6.877,21.73,15.4,26.652Z",
    transform: "translate(-348.382 -24.037)",
    fill: "#972222"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571",
    transform: "translate(7.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570",
    style: {
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M367.63,28.535l8.691-5.051c-7.574-4.325-14.37-4.712-19.284-1.854l-8.69,5.051c4.914-2.858,11.71-2.471,19.284,1.854Z",
    transform: "translate(-348.346 -19.797)",
    fill: "#972222"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2572",
    "data-name": "Group 2572",
    transform: "translate(0 5.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M371.052,24.737c-15.228-8.7-27.321-1.459-27.269,16.047.049,29.957,24.436,69.476,27.011,73.607.113.206.2.335.226.387.621-.262,27.108-11.657,27.108-42.961C398.074,54.388,385.969,33.4,371.052,24.737Zm-.145,50c-8.523-4.922-15.425-16.857-15.4-26.652.016-4.914,1.757-8.36,4.566-9.944s6.673-1.354,10.932,1.108c8.523,4.922,15.417,16.861,15.389,26.672-.028,9.795-6.967,13.737-15.49,8.815Z",
    transform: "translate(-343.783 -21.05)",
    fill: "#ff3a3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2574",
    "data-name": "Group 2574",
    transform: "translate(27.261 3.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2573",
    "data-name": "Group 2573",
    style: {
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M344.948,114.07l8.695-5.051C360.9,104.8,377.4,92.493,377.4,67.792c-.052-17.429-12.161-38.426-27.083-47.08l-8.691,5.051c14.922,8.658,27.031,29.651,27.083,47.08,0,24.7-16.5,37-23.762,41.227Z",
    transform: "translate(-341.627 -20.712)",
    fill: "#972222"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.e118e2a3219cf5b37f917d2b6f4f9034.svg";
export { ForwardRef as ReactComponent };